import { render, staticRenderFns } from "./schedule-detail.vue?vue&type=template&id=ae39b1f8&scoped=true"
import script from "./schedule-detail.vue?vue&type=script&lang=js"
export * from "./schedule-detail.vue?vue&type=script&lang=js"
import style0 from "./schedule-detail.vue?vue&type=style&index=0&id=ae39b1f8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae39b1f8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gameclient/gameclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ae39b1f8')) {
      api.createRecord('ae39b1f8', component.options)
    } else {
      api.reload('ae39b1f8', component.options)
    }
    module.hot.accept("./schedule-detail.vue?vue&type=template&id=ae39b1f8&scoped=true", function () {
      api.rerender('ae39b1f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/popup/schedule-detail.vue"
export default component.exports